import React from "react";
import { IFeedbackQuestion } from "./feedback.type";
import { Typography } from "@material-ui/core";
import { feedbackStyle } from "./style";
import {
	FreeTextFeedbackQuestion,
	MultipleChoiceFeedbackQuestion,
	RatingFeedbackQuestion,
	ScaleFeedbackQuestion,
} from "./questions";
import DataProvider from "../../provider";
import { useParams } from "react-router";

export const FeedbackQuestion: React.FC<IFeedbackQuestion> = (
	props: IFeedbackQuestion
) => {
	const { question } = props;
	const classes = feedbackStyle();
	const dataProvider = DataProvider(
		process.env.REACT_APP_WAREHOUSE_API || ""
	);
	const params = useParams<{ id: string }>();

	if (!question) {
		return null;
	}

	let QuestionComponent: React.FC<
		IFeedbackQuestion & { onChange?: (id: string, value: string) => void }
	> = () => null;

	const handleChange = (questionId: string, value: string) => {
		props.onAnswered && props.onAnswered(questionId);
		dataProvider(`b2c/feedbackCampaign/answer/`, {
			method: "POST",
			body: JSON.stringify({
				lockerSellingOrderId: params.id,
				questionId,
				answer: value,
			}),
		}).catch((e) => {});
	};

	switch (question.type) {
		case "scale":
			QuestionComponent = ScaleFeedbackQuestion;
			break;
		case "rating":
			QuestionComponent = RatingFeedbackQuestion;
			break;
		case "multiple_choice":
			QuestionComponent = MultipleChoiceFeedbackQuestion;
			break;
		case "free_text":
			QuestionComponent = FreeTextFeedbackQuestion;
			break;
		default:
			return null;
	}

	return (
		<div className={classes.questionContainer} style={{ width: "90dvw" }}>
			<Typography variant="body1" className={classes.questionText}>
				{question.question}
			</Typography>
			<QuestionComponent question={question} onChange={handleChange} />
		</div>
	);
};
